<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <ik-data-table
    ref="dataTable"
    :model="model"
    entity-name="allergName"
    icon="mdi-chart-bubble"
  >
    <template #item.icon="{item}">
      <v-icon>{{ item.icon }}</v-icon>
    </template>
    <template
      #item.removeImage="{item}"
    >
      <v-btn
        :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
        :icon="!$vuetify.breakpoint.lgAndUp"
        :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
        :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
        color="amber lighten-4 black--text"
        elevation="0"
        small
        @click.stop="removeImage(item)"
      >
        <template v-if="!$vuetify.breakpoint.lgAndUp">
          <v-icon color="white">
            mdi-cog
          </v-icon>
        </template>
        <template v-if="$vuetify.breakpoint.lgAndUp">
          <div
            :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
            :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
          >
            {{ $t('removeImage') }}
          </div>
        </template>
      </v-btn>
    </template>
  </ik-data-table>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Allergen, { removeAllergenImage } from '@/model/dataLayer/api/dish/Allergen'
import { showSuccessMessage } from '@/model/utils/utils'
import i18n from '@/i18n'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: Allergen
    })
  },
  methods: {
    async removeImage (item) {
      await removeAllergenImage(item.id)
      await this.$refs.dataTable.reload()
      showSuccessMessage(i18n.t('DeletionSuccessful'))
    }
  }
}
</script>
